export const BANK_ADDRESS_PARAM_IDS = {
  currencyCode: 'currencyCode',
  bankName: 'bankName',
} as const;
